import { getHintList } from '@/api/api_hint'

const state = {
  hintData: []
}

const mutations = {
  SET_SOLUTION_DATA: (state, data) => {
    state.hintData = data
  }
}

const actions = {
  actions_getHintList ({ commit }, tmguid) {
    console.log('actions_getHintList--tmguid=' + tmguid)
    state.hintData = []
    return new Promise((resolve, reject) => {
      getHintList(tmguid).then(response => {
        const data = response.data
        if (data.isOk) {
          commit('SET_SOLUTION_DATA', data.data)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  hintList: state => state.hintData
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/hintListData.js